class ModalVideoPlayer {
    constructor(el) {
        const target = el.getAttribute('data-target');

        if(target) {
            this.targetEl = $(target);
            this.playButton = this.targetEl.find('.play');
            this.videoPlayer = this.targetEl.find('[data-component-video-player]');
        }

        this.initEvents();
    }

    initEvents() {
        if (this.videoPlayer.length)
        {
            if(this.targetEl.length) {
                this.targetEl.on('hidden', () => {
                    this.videoPlayer.get(0).pause();
                });
            }

            if(this.playButton.length) {
                this.playButton.on('click', () => {
                    this.playButton.hide();

                    this.videoPlayer.get(0).play();
                    this.videoPlayer.get(0).controls = true;
                });
            }
        }
    }
}

export default ModalVideoPlayer;
